import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["title"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 1,
  class: "personIcon"
}

import User from '@/models/user';
import { getPhotoUrl } from '@/utilities/get-media-url';
import { IonImg } from '@ionic/vue';
import { computed, PropType, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProfileIcon',
  props: {
  user: {
    type: [Object, null, undefined] as PropType<User | null | undefined>,
    required: true
  }
},
  emits: ['change'],
  setup(__props) {

const props = __props;





const isProfilePictureFetched = ref(true);

const profilbild = computed(() => {
  if (!props.user) {
    return false;
  }
  const picture = props.user.profilbild;
  return picture ? getPhotoUrl(picture, { thumbnail: true }) : false;
});

const usernameInitials = computed(() => {
  if (!props.user) {
    return '';
  }
  const name = props.user.username;
  const words = name.split(' ');
  const firstLetters = words.map((word: string) => word[0]);
  return firstLetters.join('');
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex personIcon cursor-pointer",
    title: _ctx.$t('immobilie.updatePerson'),
    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('change')), ["stop"]))
  }, [
    (profilbild.value && isProfilePictureFetched.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(IonImg), {
            src: profilbild.value,
            onIonError: _cache[0] || (_cache[0] = ($event: any) => (isProfilePictureFetched.value = false))
          }, null, 8, ["src"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(usernameInitials.value), 1))
  ], 8, _hoisted_1))
}
}

})